{
  "fr": {
    "headlines": {
      "vehiclePlaque": {
        "title": "Plaque de dédicace"
      },
      "vehicleOverview": {
        "paints": "Peintures %{model}",
        "location": "Où est le vaisseau ?",
        "picture": "Image du vaisseau"
      },
      "vehicleLog": {
        "create": "Nouvelle entrée du journal",
        "edit": "Modifier l'entrée du journal",
        "public": "Journal de bord : %{vehicle}"
      },
      "hangarShare": "Lien de partage",
      "locations": {
        "index": "Lieux",
        "places": "Tous les lieux"
      },
      "admin": {
        "locations": {
          "index": "Lieux"
        },
        "blueprints": {
          "index": "Plans",
          "materials": "Matériaux",
          "stats": "Statistiques",
          "sources": "Sources"
        },
        "missions": {
          "index": "Missions"
        },
        "dashboard": {
          "title": "Tableau de bord",
          "visitsPerDay": "Visites par jour",
          "visitsPerMonth": "Visites par mois",
          "mostViewedPages": "Pages les plus vues",
          "registrationsPerMonth": "Inscriptions par mois"
        },
        "models": {
          "index": "Modèles",
          "edit": {
            "index": "Modifier le modèle",
            "fleetchart": "Images de diagramme de flotte",
            "positions": "Postes d'équipage",
            "hardpoints": "Points d'attache",
            "cargoAndFuel": "Carburant",
            "cargoHolds": "Soutes à cargaison",
            "metrics": "Métriques",
            "prices": "Prix",
            "docks": "Quais",
            "modules": "Modules",
            "paints": "Peintures",
            "videos": "Vidéos",
            "images": "Images",
            "itemPrices": "Prix des articles",
            "linkModule": "Lier un module existant",
            "loaners": "Prêts",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Améliorations",
            "packages": "Paquets",
            "linkUpgrade": "Lier une amélioration existante",
            "history": "Historique"
          },
          "new": "Nouveau modèle",
          "show": "Modèle",
          "images": "Images",
          "tableConfigurationModal": "Configuration du tableau"
        },
        "components": {
          "index": "Composants",
          "new": "Nouveau composant",
          "edit": {
            "index": "Modifier le composant",
            "itemPrices": "Prix des articles",
            "history": "Historique"
          }
        },
        "modelPaints": {
          "index": "Peintures",
          "new": "Nouvelle peinture",
          "edit": "Modifier la peinture",
          "copy": "Copier la peinture vers un vaisseau",
          "bulkCopy": "Copier %{count} peintures vers un vaisseau"
        },
        "modelModules": {
          "index": "Modules",
          "new": "Nouveau module",
          "edit": "Modifier le module",
          "models": "Modèles liés",
          "prices": "Prix",
          "hardpoints": "Points d'attache",
          "docks": "Quais",
          "cargoHolds": "Soutes à cargaison",
          "history": "Historique"
        },
        "unlistedModels": {
          "index": "Vaisseaux des fichiers de jeu sans modèle",
          "link": "Lier à un vaisseau du catalogue"
        },
        "manufacturers": {
          "index": "Fabricants",
          "new": "Nouveau fabricant",
          "edit": {
            "index": "Modifier le fabricant"
          }
        },
        "announcements": {
          "index": "Annonces",
          "new": "Nouvelle annonce",
          "edit": "Modifier l'annonce",
          "deliveries": "Envoi",
          "manualPosts": "Publications à copier"
        },
        "supporterContributions": {
          "index": "Contributions des soutiens",
          "new": "Nouvelle contribution de soutien",
          "edit": "Modifier la contribution de soutien",
          "perMonth": "Contributions par mois"
        },
        "fundingGoals": {
          "index": "Objectifs de financement",
          "new": "Nouvel objectif de financement",
          "edit": "Modifier l'objectif de financement"
        },
        "homepage": "Page d’accueil",
        "gameEvents": {
          "index": "Événements du jeu",
          "new": "Nouvel événement du jeu",
          "edit": "Modifier l'événement du jeu"
        },
        "users": {
          "index": "Utilisateurs",
          "edit": "Modifier l'utilisateur",
          "fleets": "Flottes",
          "inventories": "Inventaires",
          "supporterContributions": "Contributions des soutiens"
        },
        "vehicles": {
          "index": "Véhicules",
          "edit": "Modifier le véhicule"
        },
        "fleets": {
          "index": "Flottes",
          "edit": "Modifier la flotte",
          "members": "Membres",
          "memberEdit": "Modifier le membre",
          "history": "Historique",
          "roles": "Rôles",
          "inventories": "Inventaires",
          "inventoryItems": "Entrées"
        },
        "fleetFidClaims": {
          "index": "Réclamations d’ID de flotte"
        },
        "destroyedFleets": {
          "index": "Flottes détruites"
        },
        "admins": {
          "index": "Administrateurs",
          "new": "Nouvel administrateur",
          "edit": "Modifier l'administrateur"
        },
        "oauthApplications": {
          "index": "Applications OAuth",
          "new": "Nouvelle application OAuth",
          "edit": "Modifier l'application OAuth",
          "reject": "Refuser %{name}",
          "rejectBulk": "Refuser %{count} applications"
        },
        "features": {
          "index": "Indicateurs de fonctionnalités",
          "show": "Détails de la fonctionnalité",
          "globalState": "État global",
          "groups": "Groupes",
          "actors": "Acteurs",
          "selfService": "Libre-service",
          "percentageOfActors": "Pourcentage des acteurs",
          "percentageOfTime": "Pourcentage du temps",
          "addActor": "Ajouter un acteur",
          "history": "Historique",
          "addUser": "Activer pour un utilisateur",
          "addFleet": "Activer pour une flotte",
          "enabledUsers": "Utilisateurs activés",
          "enabledFleets": "Flottes activées"
        },
        "rsiApiStatus": {
          "index": "Statut de l'API RSI"
        },
        "images": {
          "index": "Images"
        },
        "imports": {
          "index": "Imports"
        },
        "notifications": {
          "index": "Notifications"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "Tests Visuels",
          "notifications": "Notifications"
        },
        "buildCompare": {
          "index": "Comparer les builds"
        }
      },
      "welcome": "Bienvenue sur",
      "welcomeShips": "Derniers vaisseaux",
      "welcomeImages": "Images Aléatoires",
      "ships": {
        "index": "Index des vaisseaux",
        "fleetchart": "Fleetchart des vaisseaux"
      },
      "images": "Index des images",
      "stats": "Statistiques",
      "notFound": "Erreur de navigation",
      "forbidden": "Accès refusé",
      "subscriptionRequired": "Fonctionnalité soutenue",
      "featureNotReady": "Bientôt disponible",
      "inviteInvalid": "Lien d'invitation invalide",
      "accessDenied": "Accès refusé",
      "serverError": "Erreur du serveur",
      "offline": "Connexion perdue",
      "invalidRequest": "Requête invalide",
      "comments": "Commentaires",
      "login": "Se connecter",
      "hangar": {
        "index": "Mon Hangar",
        "preview": {
          "title": "Votre hangar",
          "lead": "Suivez chaque vaisseau que vous possédez — gratuitement avec un compte FleetYards.net."
        },
        "alternativeNames": "Noms alternatifs",
        "stats": "Statistiques",
        "public": "Hangar de %{user}",
        "import": "Importer",
        "wishlist": "Liste de souhaits",
        "blueprints": "Plans",
        "publicStats": "Statistiques",
        "publicWishlist": "Liste de souhaits de %{user}",
        "resetIngame": "Réinitialiser les vaisseaux obtenus dans le jeu",
        "buybacks": "Pledges rachetables",
        "paints": "Peintures",
        "flair": "Décorations de hangar",
        "upgrades": "Améliorations / CCU",
        "equipment": "Équipement FPS",
        "shipComponents": "Composants de vaisseau",
        "imports": "Imports"
      },
      "buybackSync": "Synchroniser les pledges rachetables RSI",
      "syncExtension": "Synchroniser le hangar RSI",
      "editMyVehicle": "Éditer mon %{vehicle}",
      "vehicleLoadout": "Configuration pour %{vehicle}",
      "nameMyVehicle": "Nommer mon %{vehicle}",
      "editGroups": "Editer les groupes",
      "newVehicles": "Ajouter des vaisseaux",
      "myVehicleAddons": "Ajouter des modules / mises à jour pour %{vehicle}",
      "myVehicleLoadouts": "Loadouts pour %{vehicle}",
      "addToHangar": "Ajoutez «%{model}» à votre Hangar",
      "blueprintAddToHangar": "Ajoutez «%{blueprint}» à votre Hangar",
      "impressum": "Mentions légales",
      "privacy": "Politique de confidentialité",
      "cookie": "Politique relative aux cookies",
      "requestPassword": "Demander un mot de passe",
      "changePassword": "Modifier le mot de passe",
      "confirmAccess": "Confirmer l'accès",
      "setEmail": "Définir votre adresse e-mail",
      "oauthAuthorize": "Autoriser l'application",
      "filterModels": "Filtrer les vaisseaux",
      "filterVehicles": "Filtrer Hangar",
      "fleets": {
        "directory": "Annuaire des flottes",
        "owners": "Propriétaires",
        "add": "Créer une nouvelle Flotte",
        "invites": "Invitations à la flotte",
        "inviteUrls": "Liens d'invitation",
        "members": {
          "index": "Members",
          "worldmap": "Carte du monde des membres",
          "starmap": "Carte stellaire des membres",
          "health": "État des membres"
        },
        "squadrons": {
          "index": "Escadrons",
          "create": "Créer un escadron",
          "edit": "Modifier l'escadron",
          "formDetails": "Détails",
          "formAppearance": "Apparence",
          "formDiscord": "Discord",
          "ranks": "Grades d'escadron",
          "editMember": "Modifier le membre de l'escadron",
          "editRank": "Modifier le grade d'escadron",
          "teams": "Équipes",
          "addMembers": "Ajouter des membres",
          "members": "Membres"
        },
        "stats": "Statistiques",
        "preview": {
          "title": "Votre flotte",
          "lead": "Rassemblez votre org — gratuitement avec un compte FleetYards.net."
        },
        "settings": {
          "fleet": "Paramètres de la Flotte",
          "rsi": "ID de flotte et RSI",
          "membership": "Paramètres des membres",
          "roles": "Rôles de flotte",
          "squadrons": "Escadrons de la flotte",
          "allies": "Alliés de la flotte",
          "notifications": "Paramètres de notification",
          "inAppNotifications": "Notifications dans l'application",
          "discord": "Discord",
          "calendar": "Calendrier",
          "contracts": "Paramètres des contrats",
          "features": "Fonctionnalités de la flotte"
        },
        "inviteMember": "Inviter un nouveau membre",
        "calendarSubscription": "Abonnement au calendrier",
        "missions": {
          "index": "Missions",
          "create": "Créer une mission",
          "edit": "Modifier la mission",
          "editDetails": "Détails",
          "editDescription": "Description & couverture",
          "editTeams": "Équipes & places",
          "teams": "Équipes",
          "ships": "Vaisseaux",
          "slots": "Places",
          "addTeam": "Ajouter une équipe",
          "editTeam": "Modifier l'équipe",
          "addShip": "Ajouter un vaisseau",
          "editShip": "Modifier le vaisseau"
        },
        "events": {
          "expandShip": "Ajouter des places",
          "index": "Événements",
          "calendar": "Calendrier",
          "create": "Créer un événement",
          "edit": "Modifier l'événement",
          "editDetails": "Détails",
          "editSchedule": "Planification",
          "editSignup": "Inscription",
          "editDescription": "Description & couverture",
          "editTeams": "Équipes & places",
          "spawn": "Générer un événement",
          "details": "Détails de l'événement",
          "schedule": "Planification",
          "settings": "Paramètres",
          "lifecycle": "Cycle de vie",
          "signupTitle": "Je m'inscris",
          "yourSignup": "Votre inscription",
          "spawnedFrom": "Généré à partir de cette mission",
          "pickTemplate": "Choisir un modèle de mission",
          "unassignedSignups": "Inscriptions non attribuées",
          "eventTeam": "Équipe de l'événement",
          "grantRole": "Attribuer un rôle",
          "editTeam": "Modifier l'équipe",
          "addTeam": "Ajouter une équipe",
          "editShip": "Modifier le vaisseau",
          "addShip": "Ajouter un vaisseau",
          "assignSlotFor": "Attribuer une place à %{username}",
          "reassignSlotFor": "Réattribuer une place à %{username}"
        },
        "memberNickname": "Surnom du membre",
        "editRole": "Modifier le rôle",
        "contracts": {
          "index": "Contrats",
          "create": "Créer un contrat",
          "edit": "Modifier le contrat",
          "progress": "Progression",
          "crew": "Équipage",
          "items": "Marchandises",
          "editItem": "Modifier les marchandises",
          "addItem": "Ajouter des marchandises",
          "views": {
            "open": "Contrats",
            "closed": "Contrats clos",
            "mine": "Mes contrats",
            "completed": "Contrats terminés"
          }
        }
      },
      "hangarGroup": {
        "create": "Créer un groupe",
        "edit": "Modifier le groupe"
      },
      "compare": {
        "ships": "Comparer les vaisseaux"
      },
      "settings": {
        "account": "Mon compte",
        "profile": "Paramètres du profil",
        "hangar": "Paramètres de Hangar",
        "privacy": "Paramètres de confidentialité",
        "privacySections": {
          "analytics": "Statistiques d'utilisation",
          "onlineStatus": "Statut en ligne",
          "supporters": "Page des soutiens"
        },
        "features": "Indicateurs de fonctionnalités",
        "connections": "Connexions",
        "oauthApplications": "Applications OAuth",
        "notifications": "Paramètres de notification",
        "verify": "Vérifier votre compte RSI",
        "security": {
          "index": "Sécurité du Compte",
          "twoFactor": "Authentification à deux facteurs"
        },
        "twoFactor": {
          "enable": "Activer l'authentification à deux facteurs",
          "disable": "Désactiver l'authentification en deux étapes",
          "backupCodes": "Générer des codes de sauvegarde"
        },
        "calendar": "Abonnement au calendrier",
        "donations": "Dons"
      },
      "oauthApplications": {
        "new": "Nouvelle application OAuth",
        "edit": "Modifier l'application OAuth"
      },
      "roadmap": "Roadmap des vaisseaux",
      "tools": {
        "index": "Outils",
        "travelTimes": "Temps de trajet",
        "cargoGrids": "Grilles de cargaison",
        "tradeRoutes": "Routes commerciales"
      },
      "rsiVerification": "Vérifier votre compte RSI",
      "support": "Soutenir FleetYards.net",
      "supporters": "Merci à nos soutiens",
      "appUpdate": "Une nouvelle version est disponible",
      "installApp": {
        "offer": "Emportez FleetYards avec vous",
        "ios": "Installer FleetYards"
      },
      "supportHint": {
        "hangarSync": "Ravis d'avoir pu t'aider avec la synchro",
        "vehicleAdded": "Ton hangar s'agrandit",
        "fleetCreated": "Une nouvelle flotte — bravo !",
        "loginMilestone": "Merci de revenir nous voir",
        "visitMilestone": "FleetYards te plaît ?"
      },
      "vehicle": {
        "bulkGroupEdit": "Ajouter/Retirer des groupes"
      },
      "pagination": {
        "count": "%{current} sur %{total}"
      },
      "models": {
        "index": "Modèles"
      },
      "modals": {
        "models": {
          "displayOptions": "Options d'affichage"
        }
      },
      "visualTests": {
        "overview": "Aperçu",
        "panels": "Panneaux",
        "buttons": "Boutons",
        "media": "Médias",
        "charts": "Graphiques",
        "blueprints": "Plans",
        "squadrons": "Escadrons",
        "alerts": "Alertes",
        "verifiedBadges": "Badges de vérification",
        "chips": "Chips des tests visuels",
        "events": "Événements",
        "typography": "Typographie",
        "forms": "Formulaires",
        "tables": "Tables",
        "lists": "Listes",
        "metrics": "Métriques",
        "states": "États",
        "notifications": "Notifications",
        "dedicationPlaques": "Plaques de dédicace",
        "syncModal": "Modale Sync",
        "buybackSyncModal": "Modale Sync des rachats",
        "rsiVerificationModal": "Modale de vérification RSI",
        "fleetRsiVerificationModal": "Modale de vérification RSI de la flotte",
        "overlays": "Superpositions",
        "installPrompt": "Invite d'installation",
        "supportHint": "Indicateur de soutien",
        "notificationCenter": "Centre de notifications",
        "themes": "Thèmes"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item",
        "transfer": "Transférer du stock",
        "transfers": "Transferts",
        "acceptTransfer": "Accepter le transfert",
        "pickItem": "Choisir un objet",
        "crafting": "Fabrication",
        "reportTransfer": "Signaler le transfert"
      },
      "notifications": {
        "index": "Notifications"
      },
      "payouts": {
        "index": "Répartition",
        "summary": "Résumé",
        "participants": "Participants",
        "entries": "Écritures",
        "balances": "Soldes",
        "transfers": "Liste des versements",
        "addEntry": "Enregistrer un montant",
        "editEntry": "Modifier l'écriture",
        "addParticipant": "Ajouter un participant",
        "tours": {
          "index": "Expéditions",
          "create": "Créer une expédition",
          "join": "Rejoindre cette expédition"
        },
        "declineExpense": "Refuser la dépense"
      },
      "relationships": {
        "user": {
          "index": "Amis",
          "add": "Ajouter un ami"
        },
        "fleet": {
          "add": "Ajouter un allié"
        }
      },
      "fleet": {
        "contractCovers": "Visuels de contrat"
      },
      "component": {
        "temperature": "Température",
        "misfire": "Défaillance",
        "history": "Historique",
        "craftedFrom": "Fabriqué à partir de",
        "identity": "Détails",
        "metrics": "Caractéristiques",
        "requiredTags": "S'installe sur un port offrant",
        "tags": "Tags",
        "physical": "Physique",
        "damageTaken": "Dégâts subis",
        "durability": "Durabilité",
        "selfRepair": "Autoréparation",
        "distortion": "Distorsion",
        "splineJump": "Saut en orbite"
      },
      "commodity": {
        "priceHistory": "Historique des prix",
        "identity": "Détails",
        "usedIn": "Utilisée dans"
      },
      "commodities": {
        "index": "Marchandises"
      },
      "components": {
        "index": "Composants"
      },
      "blueprints": {
        "index": "Plans"
      },
      "missions": {
        "index": "Missions"
      },
      "missions": {
        "index": "Missions"
      },
      "equipment": {
        "index": "Équipement",
        "metrics": "Caractéristiques",
        "identity": "Détails",
        "craftedFrom": "Fabriqué à partir de"
      }
    }
  }
}
